'use strict';

/*global services*/
/*global isEmpty*/

(function ($) {
    $.extend($.validator.defaults, {
        errorPlacement: function (error, element) {
            var $inputWrapper = $(element).closest('.form-control-wrapper, .form-radio');
            
            //zobrazeni chyby je podmineno elementem s .field-errors            
            var $helpBlock = $inputWrapper.next('.field-errors');
            
            /*
            if (!$helpBlock.length) {
                $helpBlock = $('<div>', { class: 'field-errors' });
                $helpBlock.insertAfter($inputWrapper);
            }
            */
            
            $helpBlock.append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);

            if (!isEmpty(element.id)) {
                $(element.form).find('label[for=' + element.id + ']').addClass(errorClass);
            }

            $(element).closest('.form-group').addClass('has-error');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);

            if (!isEmpty(element.id)) {
                $(element.form).find('label[for=' + element.id + ']').removeClass(errorClass);
            }

            $(element).closest('.form-group').removeClass('has-error');
        },
        errorElement: 'span',
        errorClass: 'form-input-error',
        validClass: 'form-input-valid'
    });
    
    $.remoteCORS = function (method, action) {
        action = action || 'validators';
        return {
            url: services.get('configurations').param('DomainURL') + '/?action=' + action + '&method=' + method,
            type: 'post',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        };
    };
})(jQuery);
